import { useState, useEffect } from "react";
import { getPreviousOrders } from "../../../../services/order";
import DateView from "../../DateView/DateView";
import NormalOrdersList from "./NormalOrdersList/NormalOrdersList";
import Loading from "../../../UI/Loading/Loading";
import EmptyContent from "../../../UI/EmptyContent/EmptyContent";
import classes from "./NormalOrders.module.css";

const NormalOrders = () => {
  const [isOrdersLoading, setIsOrdersLoading] = useState(true);
  const [ordersLoadingError, setOrdersLoadingError] = useState("");
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setIsOrdersLoading(true);
        setOrdersLoadingError("");
        const response = await getPreviousOrders();
        const {
          data: { datesList },
        } = response;
        setOrders(datesList);
      } catch (err) {
        setOrdersLoadingError("ُحدث خطأ أثناء تحميل طلباتك السابقة");
      } finally {
        setIsOrdersLoading(false);
      }
    };
    fetchOrders();
  }, []);

  return (
    <ol className={classes["normal-orders"]}>
      {isOrdersLoading ? (
        <Loading className={classes["normal-orders__loading"]} />
      ) : ordersLoadingError || orders.length === 0 ? (
        <EmptyContent
          className={classes["normal-orders__empty"]}
          message="لا يوجد طلبات سابقة لعرضها !"
          withAction
        />
      ) : (
        orders.map((ordersGroup, index) => (
          <li key={index} className={classes["normal-orders__list-item-group"]}>
            <div className={classes["normal-orders__date-wrapper"]}>
              <DateView date={ordersGroup.createdAt} />
            </div>
            <NormalOrdersList orders={ordersGroup.orderList} />
          </li>
        ))
      )}
    </ol>
  );
};

export default NormalOrders;
